/*
React nav component
*/

import { bubble as Menu } from 'react-burger-menu';

export default class TopNav extends React.Component {
  constructor(props) {
    super(props);

    this.style = {};

    this.state = {

    };
  }

  showSettings(event) {
    event.prefentDefault();
  }

  render() {
    var content = (
      <div>
      <Menu burgerButtonClassName='my-burger-button'>
        <a id="homeButton" className="menu-item" href='/'><i className='fa fa-fw fa-home'></i><span>Home</span></a>
        <a id="cvButton" className="menu-item" href='/#cv'><i className='fa fa-fw fa-file-text'></i><span>CV</span></a>
        <a id="mapButton" className="menu-item" href='/#map'><i className='fa fa-fw fa-leaf'></i><span>Leaflet Map</span></a>
        <a id="blogButton" className="menu-item" href='/mmistakes-blog/splash-page'><i className='fa fa-fw fa-rss'></i><span>Jekyll Blog</span></a>
      </Menu>


</div>
      );

      return content;
    }
  };



// WEBPACK FOOTER //
// src/js/view/component/nav.jsx